<template>
  <v-container>
    <v-row>
      <v-col>
        <client-subscription :userId="userId"></client-subscription>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <client-challenges :userId="userId"></client-challenges>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <client-courses :userId="userId"></client-courses>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClientSubscription from "../blocks/ClientSubscription";
import ClientChallenges from "../blocks/registrations/ClientChallenges";
import ClientCourses from "../blocks/registrations/ClientCourses";

export default {
  name: "ClientBilling",
  components: {
    ClientSubscription,
    ClientChallenges,
    ClientCourses
  },
  props: ["userId"],
}
</script>